import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function PaidRoute({ children }) {
  const { user, loading } = useAuth();
  const [checkingPayment, setCheckingPayment] = useState(true);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (loading) return; // wait for AuthContext's auth check to resolve before deciding anything
    if (!user) {
      setCheckingPayment(false);
      return;
    }
    setCheckingPayment(true);
    api
      .get("/billing/subscription")
      .then((res) => setIsActive(!!res.data?.is_active))
      .catch(() => setIsActive(false))
      .finally(() => setCheckingPayment(false));
  }, [user, loading]);

  if (loading || checkingPayment) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="paid-route-loading-screen">
        <CircleNotch className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isActive) {
    return <Navigate to="/billing" replace />;
  }

  return children;
}
